var map = {
	"./advice.svg": 431,
	"./contacted_matches.svg": 432,
	"./copy.svg": 271,
	"./correct-answer.svg": 269,
	"./delete.svg": 272,
	"./downward-arrow.svg": 433,
	"./edit.svg": 273,
	"./email.svg": 274,
	"./icon.svg": 434,
	"./idea.svg": 267,
	"./likes.svg": 435,
	"./match-icon.svg": 268,
	"./number_of_dates.svg": 436,
	"./padlock.svg": 437,
	"./peach.svg": 95,
	"./peach_badge.svg": 275,
	"./performance.svg": 159,
	"./quiz.svg": 160,
	"./right-arrow.svg": 438,
	"./search.svg": 276,
	"./share.svg": 439,
	"./side-nav.svg": 440,
	"./stats.svg": 161,
	"./swipe-arrow.svg": 441,
	"./total_matches.svg": 442,
	"./total_swipes.svg": 443,
	"./verified-user.svg": 277,
	"./wrong-answer.svg": 270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 430;